import React, {Component} from "react";
import {connect} from "react-redux";
import Table from "../../components/Table";
import OrderItem from "./OrderItem";
import Loading from "../../components/Loading";
import GraphQLErrors from "../../components/GraphQLErrors";
import PaginatorButton from "../../components/PaginatorButton";
import {fromJS, List} from "immutable";
import {graphql} from "react-apollo";
import {LIST_ORDERS} from "../../queries/shipping";
import "./OrdersList.css";

class OrdersList extends Component {

  // UNSAFE_componentWillMount() {
  //   this.subscribe(this.props.orderId); 
  // }

  // subscribe(orderId) {
  //   if (this.unsubscribe) {
  //     this.unsubscribe();
  //   }
  //   this.unsubscribe = this.props.subscribeToUpdates(this.props, {});
  // } 

  render() {
    let {loading, error, shippingOrders} = this.props.data;
    if (loading) return <Loading />
    if (error) return <GraphQLErrors error={error} />
    let tableHeader = List([
      "Order #",
      "Items",
      "Ship To",
      "Country",
      "Warehouse",
      "Prep Date",
      "Pickup Date",
      "",
      "Fulfillment",
    ])         
    let shippingOrdersData = fromJS(shippingOrders); 
    return (
      <div>
        <Table 
          data={shippingOrdersData.get("entries")} 
          renderer={OrderItem} 
          onItemClick={this.handleItemClick.bind(this)}
          tableHeader={tableHeader}
          extraClassName="OrdersList"
          itemKey="orderId"
          mode="table"
          showCount={true}
          selected={this.props.selectedId}
          />
        <PaginatorButton 
          metadata={shippingOrdersData.get("metadata")} 
          onNext={this.handleNext.bind(this)}
          />
      </div>
    )
  }

  handleNext(afterId) {
    this.props.data.fetchMore({
      variables: {
        pagination: {
          after: afterId
        }
      },
      updateQuery: (prev, {fetchMoreResult}) => {
        if (!fetchMoreResult) return prev;
        return {
          shippingOrders: {
            __typename: prev.shippingOrders.__typename,
            metadata: fetchMoreResult.shippingOrders.metadata,
            entries: [...prev.shippingOrders.entries, ...fetchMoreResult.shippingOrders.entries]
          }
        }
      }
    })
  }  

  handleItemClick(itemData, e, field = "") {
    let id = itemData.get("orderId");
    if (field === "id") {
      e.stopPropagation();
      this.props.onIdClick(id);
      return;
    }    
    this.props.onSelectionChange(id);
  }  
}


const mapDispatchToProps = dispatch => ({
  // subscribeToUpdates: (props, params) => {
  //   return props.data.subscribeToMore({
  //     document: ON_NEW_CUSTOMER,
  //     updateQuery: (prev, { subscriptionData }) => {
  //       if (!subscriptionData.data) {
  //         return prev;
  //       }
  //       return update(prev, {
  //         customers: {
  //           $push: [subscriptionData.data.newCustomer]
  //         }
  //       })
  //     }
  //   })
  // },
  // subscribeToUpdates: (props, params) => {
  //   return props.data.subscribeToMore({
  //     document: ON_NEW_CUSTOMER,
  //     updateQuery: (prev, { subscriptionData }) => {
  //       if (!subscriptionData.data) {
  //         return prev;
  //       }
  //       return update(prev, {
  //         customers: {
  //           $push: [subscriptionData.data.newCustomer]
  //         }
  //       })
  //     }
  //   })
  // }  
})

const withSubscription = connect(null, mapDispatchToProps);

const withQuery = graphql(LIST_ORDERS, {
  options: (props) => ({
    fetchPolicy: "network-only",
    variables: {
      filter: {
        status: props.statusFilter,
        type: props.typeFilter,
        warehouseId: props.warehouseFilter,
        jurisdictionId: props.jurisdictionFilter,
        orderId: props.orderIdSearch,
        extOrderId: props.extOrderIdSearch,
        name: props.nameSearch,
        attName: props.attNameSearch,
        email: props.emailSearch,
        phoneNr: props.phoneNrSearch,
        notes: props.notesSearch
      }
    }
  })
})

export default withQuery(withSubscription(OrdersList));